import React from 'react';
import CrimeScene from 'src/components/crimeScene/crimeScene';
import CrimeSceneLayout from 'src/components/crimeScene/crimeScene-layout';


const CrimeScenePage: React.FC = () => {
  return (
    <CrimeSceneLayout children={<CrimeScene/>}></CrimeSceneLayout>
  );
};

export default CrimeScenePage;